module.exports = __webpack_public_path__ + "static/media/linux.0adfc5c9.png";